<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs6 class="fillContent" style="position: relative">
      <div class="px-4 fillContent" style="overflow: auto">
        <v-switch v-if="lay_scope != 'MIS'" hide-details v-model="isBasic" label="Basic Layer" />
        <v-text-field hide-details :label="$t('Admin.MapLayer.Form.Libelle')" v-model="lay_libelle" />
        <v-text-field
          hide-details
          v-if="showGroupField"
          :label="$t('Admin.MapLayer.Form.Group')"
          v-model="lay_group_name"
        />
        <v-select
          hide-details
          v-if="showLayerScope"
          :items="scopes"
          item-text="label"
          item-value="value"
          :label="$t('Admin.MapLayer.Form.Scope')"
          v-model="lay_scope"
        >
          <template #item="{ item }">
            <v-icon v-text="item.icon" class="mr-2" />
            {{ item.label }}
          </template>
          <template #selection="{ item }">
            <v-icon v-text="item.icon" class="mr-2" />
            {{ item.label }}
          </template>
        </v-select>
        <v-select
          hide-details
          v-if="showCompanyDll"
          :items="enseignes"
          item-text="ENS_LIBELLE"
          item-value="ENS_ID"
          :label="$t('Admin.MapLayer.Form.Company')"
          v-model="ens_id"
        ></v-select>
        <v-autocomplete
          hide-details
          v-if="showMissionsDll"
          :items="adminMissions"
          item-text="MIS_LIBELLE"
          item-value="MIS_ID"
          :label="$t('')"
          v-model="mis_id"
        ></v-autocomplete>
        <v-autocomplete
          hide-details
          v-if="showMissionsGlobalDll"
          :items="missionGlobals"
          item-text="MIG_LIBELLE"
          item-value="MIG_ID"
          :label="$t('')"
          v-model="mig_id"
        ></v-autocomplete>
        <v-autocomplete
          v-if="showMultiMissionsDll"
          class="mb-2"
          chips
          clearable
          deletable-chips
          multiple
          :items="adminMissions"
          persistent-hint
          hint="Layer will be auto add in mission layers"
          item-text="MIS_LIBELLE"
          item-value="MIS_ID"
          :label="$t('Admin.MapLayer.Form.Mission')"
          v-model="missionIds"
        ></v-autocomplete>
        <v-autocomplete
          v-if="showMultiMissionsGlobalDll"
          class="mb-2"
          chips
          clearable
          deletable-chips
          multiple
          :items="missionGlobals"
          persistent-hint
          hint="Layer will be auto add in smart planning layers"
          item-text="MIG_LIBELLE"
          item-value="MIG_ID"
          :label="$t('Admin.MapLayer.Form.MissionGlobal')"
          v-model="missionGlobalIds"
        ></v-autocomplete>
        <label class="text-reader v-btn theme--light ml-0">
          <div class="v-btn__content">
            {{ $t('Admin.MapLayer.Form.ReadKml') }}
            <v-icon right>mdi-file-download-outline</v-icon>
            <input type="file" ref="kmlFileInput" @change="readKmlFromFile" />
          </div>
        </label>
        <v-textarea box :label="$t('Admin.MapLayer.Form.Data')" v-model="lay_data" hide-details class="mb-4" />
        <div><admin-wizard-layer v-model="lay_config_json" /></div>
        <div v-if="hasLayerConfig">
          <strong>{{ $t('Admin.MapLayer.Form.Type') }} :</strong>
          {{ configLayer.type }}
          <br />
          <strong>{{ $t('Admin.MapLayer.Form.ServiceUrl') }} :</strong>
          {{ configLayer.url }}
          <br />
          <strong>{{ $t('Admin.MapLayer.Form.Layer') }} :</strong>
          {{ configLayer.layer }}
          <br />
        </div>
        <span v-else>{{ $t('Admin.MapLayer.Form.NoConfig') }}</span>
        <template v-if="hasLayerOptions">
          <strong>{{ $t('Admin.MapLayer.Form.TestOptions') }} :</strong>
          <div class="elevation-3 pa-2 my-2">
            <admin-config-layer v-if="hasLayerOptions" v-model="configLayer" />
          </div>
        </template>
        <!--<v-textarea  box :label="$t('Admin.MapLayer.Form.Config')" v-model="lay_config_json" hide-details />-->
      </div>
    </v-flex>
    <v-flex xs6 class="pa-2 fillContent" style="position: relative; overflow: hidden">
      <vl-map
        ref="mapLayer"
        :load-tiles-while-animating="true"
        :load-tiles-while-interacting="true"
        data-projection="EPSG:4326"
        class="fillContent"
      >
        <vl-view ref="view" :zoom.sync="zoom"></vl-view>
        <!-- Calque Open Street Map (Stadia Maps) -->
        <vl-layer-tile :zIndex="1">
          <vl-source-xyz
            url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}.png"
            :attributions="[
              '&copy; <a href=\'https://stadiamaps.com/\'>Stadia Maps</a> &copy; <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap contributors</a>',
            ]"
            :tile-load-function="stadiaTileLoadFunction"
          ></vl-source-xyz>
        </vl-layer-tile>
        <!-- other layers from config -->
        <component :zIndex="layer.isbaselayer ? 1 : 2" v-if="hasLayerConfig && refresh" :is="layer.cmp" v-bind="layer">
          <!-- add vl-source-* -->
          <component :is="layer.source.cmp" v-bind="layer.source">
            <!-- add static features to vl-source-vector if provided -->
            <vl-feature
              v-if="layer.source.staticFeatures && layer.source.staticFeatures.length"
              v-for="feature in layer.source.staticFeatures"
              :key="feature.id"
              :id="feature.id"
              :properties="feature.properties"
            >
              <component :is="geometryTypeToCmpName(feature.geometry.type)" v-bind="feature.geometry"></component>
            </vl-feature>

            <!-- add inner source if provided (like vl-source-vector inside vl-source-cluster) -->
            <component v-if="layer.source.source" :is="layer.source.source.cmp" v-bind="layer.source.source">
              <!-- add static features to vl-source-vector if provided -->
              <vl-feature
                v-if="layer.source.source.staticFeatures && layer.source.source.staticFeatures.length"
                v-for="feature in layer.source.source.staticFeatures"
                :key="feature.id"
                :id="feature.id"
                :properties="feature.properties"
              >
                <component :is="geometryTypeToCmpName(feature.geometry.type)" v-bind="feature.geometry"></component>
              </vl-feature>
            </component>
          </component>
          <!--// vl-source-* -->

          <!-- add style components if provided -->
          <!-- create vl-style-box or vl-style-func -->
          <component v-if="layer.style" v-for="(style, i) in layer.style" :key="i" :is="style.cmp" v-bind="style">
            <!-- create inner style components: vl-style-circle, vl-style-icon, vl-style-fill, vl-style-stroke & etc -->
            <component v-if="style.styles" v-for="(st, cmp) in style.styles" :key="cmp" :is="cmp" v-bind="st">
              <!-- vl-style-fill, vl-style-stroke if provided -->
              <vl-style-fill v-if="st.fill" v-bind="st.fill"></vl-style-fill>
              <vl-style-stroke v-if="st.stroke" v-bind="st.stroke"></vl-style-stroke>
            </component>
          </component>
          <!--// style -->
        </component>
        <!--// other layers -->
        <vl-layer-vector :zIndex="400">
          <vl-source-vector :format-factory="kmlFactory" :features="features"></vl-source-vector>
        </vl-layer-vector>
      </vl-map>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
//@ts-ignore
import KML from 'ol/format/KML.js'
import AdminWizardLayer from '@/components/admin/mapLayer/AdminWizardLayer.vue'
import AdminConfigLayer from '@/components/admin/mapLayer/AdminConfigLayer.vue'
import { LayerConfig } from '@/models/ui/LayerConfig'
import { cloneDeep } from 'lodash'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { LayerSourceType } from '@/enum/LayerSourceType'

@Component({
  name: 'AdminMapLayerForm',
  props: {
    config: {},
  },
  components: { AdminWizardLayer, AdminConfigLayer },
})
export default class AdminMapLayerForm extends Vue {
  zoom = 2
  sendingFilesInfo = {}
  config!: { missionMode: boolean }
  refresh = true
  configLayer = new LayerConfig()

  layers = []

  canRenderLayer = false

  get scopes() {
    const scope = []
    if (this.isSysAdmin) scope.push({ label: 'Global', value: 'GLO', icon: 'mdi-earth' })

    scope.push(
      ...[
        { label: 'Enseigne', value: 'ENS', icon: 'mdi-domain' },
        { label: 'Mission', value: 'MIS', icon: 'mdi-rocket' },
      ],
    )
    // BLF037 — portée Smart Planning seulement si le module est accessible (gardée pour une couche
    // qui l'a déjà).
    if (this.$store.myGetters.hasSmartPlanningModule || this.lay_scope == 'MIG') {
      scope.push({ label: 'Smart Planning', value: 'MIG', icon: 'mdi-rocket-outline' })
    }

    return scope
  }

  created() {
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
    this.$store.myActions.ADMINMISSION_ENSURE_LIST()
    this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    this.$store.myActions.GLIDER_ENSURE_LIST()
    this.configLayer = new LayerConfig(this.rawConfigLayer)
  }

  mounted() {
    setTimeout(() => this.updateSize(), 200)
  }

  //features = [ { "type": "Feature", "id": "37b7000f-b842-400e-bewmsStep-259cf6cb8bfa", "geometry": { "type": "Point", "coordinates": [ 6.6000000000000005, 43.099999999999994, 0 ] }, "properties": { "name": "D", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "7495ee56-5ec4-4d81-8b41-f6b25054987f", "geometry": { "type": "Point", "coordinates": [ 7.400000000000001, 43.130000000000024, 0 ] }, "properties": { "name": "Zc", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "da9bd45b-1d0d-4618-9358-def1bb40edc1", "geometry": { "type": "Point", "coordinates": [ 7.250000000000001, 43.099999999999994, 0 ] }, "properties": { "name": "Z1", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "8e501fe4-1922-47bc-a106-bc3a4ed626f3", "geometry": { "type": "Point", "coordinates": [ 7.43, 43.22999999999999, 0 ] }, "properties": { "name": "Z2", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "b3c42183-d775-48c1-b121-6a6603e6383f", "geometry": { "type": "Point", "coordinates": [ 7.530000000000001, 43.18000000000001, 0 ] }, "properties": { "name": "Z3", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "1b9a9177-97ed-4b6c-a44a-643bd40175a8", "geometry": { "type": "Point", "coordinates": [ 7.349999999999999, 43.05000000000001, 0 ] }, "properties": { "name": "Z4", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "db26e217-3cde-413a-ab46-fe0ed2b809f2", "geometry": { "type": "Polygon", "coordinates": [ [ [ 7.352458116435889, 43.0483365483955, 0 ], [ 7.530628505183248, 43.18188183235159, 0 ], [ 7.426296408642559, 43.2291623967177, 0 ], [ 7.249327715046727, 43.09988956080005, 0 ], [ 7.352458116435889, 43.0483365483955, 0 ] ] ] }, "properties": { "name": "Zone", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } }, { "type": "Feature", "id": "b73f2bae-7fe6-4737-92a9-ed2bf92f9592", "geometry": { "type": "LineString", "coordinates": [ [ 6.601908266143135, 43.100064213560245, 0 ], [ 7.250321211418838, 43.10078452192931, 0 ] ] }, "properties": { "name": "Sans titre - Trajet", "styleUrl": "http://localhost:8080/#m_ylw-pushpin" } } ]

  features = [] as Array<any>

  get isBasic() {
    return this.rawConfigLayer.isBasic ?? false
  }
  set isBasic(newValue: boolean) {
    const conf = cloneDeep(this.rawConfigLayer)
    conf.isBasic = newValue
    this.modified.LAY_CONFIG_JSON = JSON.stringify(conf)
  }

  get hasLayerConfig() {
    return this.rawConfigLayer.type ?? false
  }

  get rawConfigLayer() {
    return JSON.parse((this.modified.LAY_CONFIG_JSON?.length ?? 0) > 0 ? this.modified.LAY_CONFIG_JSON! : '{}')
  }

  @Watch('rawConfigLayer')
  onRawConfigLayerChange() {
    this.configLayer = new LayerConfig(this.rawConfigLayer)
  }

  //Refresh sur modification des options
  @Watch('configLayer')
  onConfigLayerChange() {
    this.refresh = false
    this.$nextTick(() => (this.refresh = true))
  }

  get layer() {
    return AloDbMapLayer.toOlLayerConfig(this.modified.id!, this.configLayer)
  }

  get hasLayerOptions() {
    return (
      this.hasLayerConfig &&
      ((this.configLayer.colorscalemin != null && this.configLayer.colorscalemax != null) ||
        Object.keys(this.configLayer.options ?? {}).some(k => this.configLayer.options[k]?.enable))
    )
  }

  @Watch('modified.LAY_CONFIG_JSON')
  onConfigUpdate() {
    this.refresh = false
    this.$nextTick(() => (this.refresh = true))
  }

  get enseignes() {
    return this.$store.myGetters.enseignes
  }

  get adminMissions() {
    return this.$store.myGetters.adminMissions
  }

  // BLF037 — scénarios autorisés pour leur enseigne, plus ceux déjà rattachés à la couche (sinon
  // l'enregistrement perdrait le rattachement).
  get missionGlobals() {
    const attached = [this.modified?.MIG_ID, ...(this.modified?.MISSION_GLOBALE_IDS ?? [])]
    return this.$store.myGetters.missionGlobals.filter(
      (mig: any) => attached.includes(mig.MIG_ID) || this.$store.myGetters.isMissionGlobalAllowed(mig),
    )
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmMapLayer
  }

  get lay_libelle() {
    return this.modified.LAY_LIBELLE!
  }
  set lay_libelle(value: string) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      LAY_LIBELLE: value,
    })
  }

  get lay_group_name() {
    return this.modified.LAY_GROUP_NAME!
  }
  set lay_group_name(value: string) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      LAY_GROUP_NAME: value,
    })
  }

  get lay_config_json() {
    return this.modified.LAY_CONFIG_JSON!
  }
  set lay_config_json(value: string) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      LAY_CONFIG_JSON: value,
    })
  }

  get lay_data() {
    return this.modified.LAY_DATA!
  }
  set lay_data(value: string) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      LAY_DATA: value,
    })
  }

  get ens_id() {
    return this.modified.ENS_ID!
  }
  set ens_id(value: number) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      ENS_ID: value,
    })
  }

  get mis_id() {
    return this.modified.MIS_ID!
  }
  set mis_id(value: number) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      MIS_ID: value,
    })
  }

  get missionIds() {
    return this.modified.MISSION_IDS!
  }
  set missionIds(value: number[]) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      MISSION_IDS: value,
    })
  }

  get mig_id() {
    return this.modified.MIG_ID!
  }
  set mig_id(value: number) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      MIG_ID: value,
    })
  }

  get missionGlobalIds() {
    return this.modified.MISSION_GLOBALE_IDS!
  }
  set missionGlobalIds(value: number[]) {
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      MISSION_GLOBALE_IDS: value,
    })
  }

  get showCompanyDll() {
    return this.lay_scope == 'ENS'
  }

  get showGroupField() {
    return !this.isBasic && this.lay_scope != 'MIS' && this.lay_scope != 'MIG'
  }

  get showLayerScope() {
    return !this.config.missionMode
  }

  get showMissionsDll() {
    return this.lay_scope == 'MIS' && !this.config.missionMode
  }

  get showMultiMissionsDll() {
    return this.lay_scope != 'MIS' && this.lay_scope != 'MIG'
  }

  get showMissionsGlobalDll() {
    return this.lay_scope == 'MIG' && !this.config.missionMode
  }

  get showMultiMissionsGlobalDll() {
    return this.lay_scope != 'MIS' && this.lay_scope != 'MIG'
  }

  get lay_scope() {
    return this.modified.LAY_SCOPE!
  }

  set lay_scope(value: string) {
    const ensId = value == 'ENS' ? this.ens_id : null
    const mis_id = value == 'MIS' ? this.mis_id : null
    const mig_id = value == 'MIG' ? this.mig_id : null
    const missionIds = this.showMultiMissionsDll ? this.missionIds : []
    const missionGlobalIds = this.showMultiMissionsGlobalDll ? this.missionGlobalIds : []
    this.$store.myActions.MAPLAYER_UPDATE_MODIFIED_ADM({
      LAY_SCOPE: value,
      ENS_ID: ensId,
      MIS_ID: mis_id,
      MIG_ID: mig_id,
      missionIds,
      missionGlobalIds,
    })
  }

  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  stadiaTileLoadFunction(tile: any, src: string) {
    fetch(src, {
      referrer: window.location.origin,
      referrerPolicy: 'origin',
    })
      .then(response => response.blob())
      .then(blob => {
        tile.getImage().src = URL.createObjectURL(blob)
      })
  }

  updateSize() {
    if (!this.$refs.mapLayer) this.$nextTick(this.updateSize)
    else
      setTimeout(() => {
        if (this.$refs.mapLayer) {
          //@ts-ignore
          this.$refs.mapLayer.updateSize()
          //this.redrawMap()
          const layData = this.lay_data
          //Trick to ensure data visualisation on startup
          this.lay_data = ''
          this.$nextTick(() => {
            this.lay_data = layData
          })
        }
      }, 200)
  }

  redrawMap() {
    //Twick force le refresh de la carte
    this.zoom += 1
    this.zoom -= 1
  }

  kmlFactory() {
    return new KML()
  }

  readKmlFromFile(ev: any) {
    const file = ev.target.files[0]
    const reader = new FileReader()
    //@ts-ignore
    reader.onload = e => (this.lay_data = e.target.result)
    reader.readAsText(file)
  }

  @Watch('lay_data')
  onModifiedDataKml(newValue: any, oldValue: any) {
    this.$nextTick(() => {
      this.features = []
      this.$nextTick(() => {
        if (this.lay_data && this.lay_data.length > 0) {
          try {
            //tente de lire les données au formats KML
            this.features = this.kmlFactory().readFeatures(this.lay_data, {
              dataProjection: 'EPSG:4326',
              featureProjection: 'EPSG:3857',
            })
          } catch {}
        }
      })
    })
  }
}
</script>

<style>
.text-reader {
  cursor: pointer;
}
.text-reader input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
}
</style>
